"use client";

import { useTranslations } from "next-intl";
import { TypewriterRotatingPhrases } from "@/components/ui/typewriter-effect";

const h1Class =
  "font-display text-[clamp(2rem,6.5vw,3.5rem)] md:text-[clamp(2.75rem,5vw,4.25rem)] leading-[1.06] tracking-[-0.02em] mb-10 sm:mb-11 md:mb-12 text-[var(--on-surface)]";

export function ServicesHeroHeadline() {
  const t = useTranslations("servicesHub");
  const phrases = t.raw("heroTypewriterPhrases") as readonly string[];

  return (
    <h1 className={h1Class} style={{ fontFamily: "var(--font-display)" }}>
      <span className="block">{t("headlinePrefix")}</span>
      <span className="mt-3 block min-h-[1.2lh] sm:mt-2.5">
        <TypewriterRotatingPhrases
          phrases={phrases}
          className="font-display text-[var(--primary)] tracking-[-0.02em]"
          reserveMinWidth
          trailing={<span aria-hidden>.</span>}
        />
      </span>
    </h1>
  );
}
